import React from "react";
import Button from "reactstrap/es/Button";

export const report_strings = {
    en: {
        reports: "Reports",
        ticket_report: "Ticket report",
        ticket_report_expl: "Browse ticket sales by period, Ticket type and Payment type.",
        unpaid_report: "Clients with missed payments",
        unpaid_report_expl: "Reports lists clients who have unpaid classes during the selected period of time.",
        renewable_ticket_report: "All active tickets that will automatically renew at the end of the validity period.",
        attendance_report: "Attendance report",
        attendance_report_expl: "Attendance report displays all classes during the selected period of time along with attendance and teacher data. You can filter report by Class type.",
        day_overview: "Day overview",
        day_overview_expl: "Compact overview of all today activities at {0}.",
        period_overview: "Period overview",
        period_overview_expl: "Compact overview of all activities at {0} during the selected period.",
        filter: "Filter",
        tickets_sold: "Tickets sold",
        go_to_ticket_report: "Go to ticket report",
        incomes: "Incomes",
        expenses: "Expenses",
        go_to_incomes: "Go to Incomes",
        go_to_expenses: "Go to Expenses",
        this_week: "This week",
        ticket_sales: "Ticket sales",
        attendance: "Attendance",
        bookings: "Bookings",
        bookings_expl: "Bookings made with OPEN Client app.",
        attendance_expl: "All clients in classes",
        expiring_tickets_report: "Expiring tickets",
        expiring_tickets_report_expl: "All tickets that will expires in less than 3 days. Tickets without expiration date are never listed here.",
        income_report: "Income report",
        income_report_expl: "All incomes for the selected period of time including ticket sales.",
        back_to_reports: "Back to reports",
        no_attendance_data: "Here you will see the attendance graph once data is available",
        since_last_week: "since last week",
        new_clients: "New clients",
        overview: "Overview",
        sales: "Sales",
        close_day: "Close Day",
        start_total: "Start total",
        cash_start_total: "Start total (cash)",
        cash_day_total: "Day total (cash)",
        day_total: "Day total",
        day_incomes: "Day incomes",
        income_total: "Income total",
        day_expenses: "Day expenses",
        no_transactions_for_day: "No transactions for this day",
        cashier_expl: "In the end of each day complete this form to keep track of your balance.",
        cashier_inc_exp_expl: "Here is the selected day summary to help you quickly update the form above:",
        update_available: "Update is available. Please click here to reload app.",
        created_between: "Created between",
        daily_activated: "Receive daily reports on my email",
        last7Days: "Last 7 days",
        last_month: "Past month",
        students_not_active_30_days: "Clients who didn't visit classes for 30 days",
        students_not_active_10_days_active: "Clients with an active ticket who didn't visit classes for 10 days",
        students_not_active_this_moth: "Clients who where attending classes last month but stopped attending this month",
        top_fifty_students: "Top 50 (Clients who attended the most classes)",
        loyal_no_ticket: "Clients who attended 50 and more classes and have no active ticket at the moment",
    },
    es: {
        reports: "Informes",
        ticket_report: "Informe de tickets",
        ticket_report_expl: "Examinar la venta de tickets por período, tipo de ticket y tipo de pago",
        unpaid_report: "Clientes con impagos",
        unpaid_report_expl: "Los informes enumeran los clientes que tienen clases sin pagar durante el período de tiempo seleccionado.",
        renewable_ticket_report: "Todos los tickets activos que se renovarán automáticamente al final del periodo de validez.",
        attendance_report: "Informe de asistencia",
        attendance_report_expl: "El informe de asistencia muestra todas las clases durante el período de tiempo seleccionado junto con los datos de asistencia y de los maestros. Puede filtrar el informe por tipo de clase.",
        day_overview: "Resumen del día",
        day_overview_expl: "Resumen compacto de todas las actividades de hoy en {0}",
        period_overview: "Resumen del período",
        period_overview_expl: "Resumen compacto de todas las actividades en {0} durante el período seleccionado",
        filter: "Filtrar",
        tickets_sold: "Tickets vendidos",
        go_to_ticket_report: "Ir al informe de tickets",
        incomes: "Ingresos",
        expenses: "Gastos",
        go_to_incomes: "Ir a Ingresos",
        go_to_expenses: "Ir a Gastos",
        this_week: "Esta semana",
        ticket_sales: "Venta de tickets",
        attendance: "Asistencia",
        bookings: "Reservas",
        bookings_expl: "Las reservas hechas con la aplicación OPEN Client",
        attendance_expl: "Todos los clientes en las clases",
        expiring_tickets_report: "Tickets que pronto expirarán",
        expiring_tickets_report_expl: "Todos los tickets que expiren en menos de 3 días",
        income_report: "Informe de ingresos",
        income_report_expl: "Todos los ingresos para el período de tiempo seleccionado",
        back_to_reports: "Volver a los informes",
        no_attendance_data: "Aquí verás el gráfico de asistencia una vez que los datos estén disponibles",
        since_last_week: "desde la semana pasada",
        new_clients: "Nuevos clientes",
        overview: "Visión general",
        sales: "Ventas",
        close_day: "Cerrar el día",
        start_total: "Total de inicio",
        cash_start_total: "Total de inicio (efectivo)",
        cash_day_total: "Total del día (efectivo)",
        day_total: "Total del día",
        day_incomes: "Ingresos del día",
        income_total: "Total de ingresos",
        day_expenses: "Gastos del día",
        no_transactions_for_day: "No hay transacciones para este día",
        cashier_expl: "Al final de cada día rellene este formulario para llevar la cuenta de su saldo.",
        cashier_inc_exp_expl: "Aquí está el resumen del día seleccionado para ayudarle a actualizar rápidamente el formulario anterior:",
        update_available: "La actualización está disponible. Haga clic aquí para recargar la aplicación.",
        created_between: "Creado entre",
        daily_activated: "Recibir informes diarios en mi correo electrónico",
        last7Days: "Últimos 7 días",
        last_month: "Mes anterior",
        students_not_active_30_days: "Clientes que no visitaron las clases durante 30 días",
        students_not_active_10_days_active: "Clientes con un ticket activo que no visitaron las clases durante 10 días",
        students_not_active_this_moth: "Clientes que asistían a las clases el mes pasado pero dejaron de asistir este mes",
        top_fifty_students: "Top 50 (Clientes que asistieron a más clases)",
        loyal_no_ticket: "Clientes que asistieron a 50 clases o más y no tienen ningún ticket activo en este momento",
    },
    ru: {
        reports: "Отчёты",
        ticket_report: "Отчет о проданных абонементах",
        ticket_report_expl: "Просмотрите информацию о продаже абонементов по периодам, типам абонементов и видам оплаты.",
        unpaid_report: "Клиенты с пропущенными оплатами",
        unpaid_report_expl: "В отчете перечислены клиенты, у которых есть неоплаченные занятия в течение выбранного периода времени.",
        renewable_ticket_report: "Все активные абонементы, которые будут автоматически продлены в конце срока действия.",
        attendance_report: "Отчет о посещении",
        attendance_report_expl: "Отчет о посещаемости отображает все классы за выбранный период времени вместе с данными о посещаемости и учителях. Вы можете отфильтровать отчет по типу класса.",
        day_overview: "Обзор дня",
        day_overview_expl: "Компактный обзор всех сегодняшних событий в {0}.",
        period_overview: "Обзор периода",
        period_overview_expl: "Компактный обзор всех событий в {0} в течении выбранного периода.",
        filter: "Фильтровать",
        tickets_sold: "Продано абонементов",
        go_to_ticket_report: "Перейти к отчету по абонементам",
        incomes: "Доходы",
        expenses: "Расходы",
        go_to_incomes: "Перейти к разделу Доходы",
        go_to_expenses: "Перейти к разделу Расходы",
        this_week: "Текущая неделя",
        ticket_sales: "Продажа абонементов",
        attendance: "Посещение",
        bookings: "Резервации",
        bookings_expl: "Резервации с помощью приложения OPEN Client.",
        attendance_expl: "Всего клиентов на классах",
        expiring_tickets_report: "Истекающие абонементы",
        expiring_tickets_report_expl: "Все абонементы, срок действия которых истекает менее чем через 3 дня. Абонементы без срока годности В этот отчет не попадают.",
        income_report: "Отчёт о доходах",
        income_report_expl: "Все доходы за выбранный период времени, включая продажу абонементов.",
        back_to_reports: "Назад к отчетам",
        no_attendance_data: "Здесь вы увидите график посещаемости, как только данные будут доступны.",
        since_last_week: "с прошлой недели",
        new_clients: "Новые клиенты",
        overview: "Обзор",
        sales: "Продажи",
        close_day: "Закрыть день",
        start_total: "Стартовая сумма",
        cash_start_total: "Стартовая сумма (наличные)",
        cash_day_total: "Общий итог дня (наличные)",
        day_total: "Общий итог дня",
        day_incomes: "Доходы за день",
        income_total: "Общий доход",
        day_expenses: "Расходы за день",
        no_transactions_for_day: "Нет операций в выбранный день",
        cashier_expl: "В конце каждого дня заполняйте эту форму, чтобы следить за своим балансом.",
        cashier_inc_exp_expl: "Ниже приведена информация за выбранное число, которая поможет вам быстро заполнить форму, приведенную выше:",
        update_available: "Доступно обновление. Пожалуйста, нажмите здесь, чтобы перезагрузить приложение.",
        created_between: "Добавленные между",
        daily_activated: "Получать ежедневные отчеты по электронной почте",
        last7Days: "Последние 7 дней",
        last_month: "Прошлый месяц",
        students_not_active_30_days: "Клиенты, не посещавшие занятия в течение 30 дней",
        students_not_active_10_days_active: "Клиенты с активным абонементом, не посещавшие занятия в течение 10 дней",
        students_not_active_this_moth: "Клиенты, которые посещали занятия в прошлом месяце, но перестали посещать в этом месяце",
        top_fifty_students: "Топ-50 (клиенты, посетившие наибольшее количество занятий)",
        loyal_no_ticket: "Клиенты, посетившие 50 и более занятий и не имеющие на данный момент активного абонемента",
    },
};
